import useSWR from 'swr';
import { getAllSpecialties } from './specialtiesService';
import { useSpecialtiesStore } from './specialtiesStore';

export function useSpecialties() {
	const { setSpecialties } = useSpecialtiesStore();

	return useSWR('specialties', getAllSpecialties, {
		onSuccess: (specialties) => {
			setSpecialties(specialties);
		},
	});
}
